import axios from 'axios';

import { ApiResponse } from '../../models/api.response.model';
import { authToken } from '../../scripts/authentication.script';

export interface ExchangeRateData {
  base: string;
  target: string;
  rate: number;
  date: string;
  source: string;
  stale: boolean;
}

export class ExchangeRateDA {
  static apiResponse: ApiResponse

  public static async getRate(
    id_company: string,
    base: string,
    target: string
  ): Promise<ApiResponse> {
    if (process.env.REACT_APP_ENVIRONMENT === 'development') {
      this.apiResponse = {
        status: 200,
        message: 'Success',
        data: {
          base: base,
          target: target,
          rate: base === 'CHF' && target === 'EUR' ? 0.9111 : 1,
          date: new Date().toISOString().split('T')[0],
          source: 'mock',
          stale: false
        }
      }
    } else {
      let url: string = `${process.env.REACT_APP_PORT_ADMIN}/${id_company}/exchange-rates?base=${base}&target=${target}`

      let config: any = {
        headers: { Authorization: authToken() }
      }

      await axios.get(url, config).then(response => {
        this.apiResponse = {
          status: response.status,
          message: response.statusText,
          data: response.data?.data ?? response.data
        }
      }).catch(error => {
        this.apiResponse = {
          status: error.response?.status ?? 500,
          message: error.response?.statusText ?? 'Error',
          data: error.response?.data?.error ?? { code: 'NETWORK_ERROR', message: error.message }
        }
      })
    }

    return this.apiResponse
  }
}
